import type { RouteRecordRaw } from "vue-router";
import { routeNames } from "@/router/constants";
import { useIntl } from "@moroku/money-webapp-components";
import { envIsDemoPreProd } from "@/config";

const { t } = useIntl();

export const getOnboardingRoutes = (): RouteRecordRaw[] => [
  {
    path: "/getting-started",
    name: routeNames.ONBOARDING_SPLASH,
    component: () => import("@/features/Onboarding/OnboardingKycCtaView.vue"),
    meta: {
      requiresAuth: false,
      title: t("onboarding_kyc_title"),
    },
  },
  {
    path: "/onboarding",
    name: routeNames.ONBOARDING_VIEW,
    component: () => import("@/features/Onboarding/OnboardingKycView.vue"),
    meta: {
      title: t("onboarding_kyc_title"),
      headerBottomMargin: false,
    },
  },
  {
    path: "/onboarding-completed",
    name: routeNames.ONBOARDING_COMPLETED_VIEW,
    component: () => import("@/features/Onboarding/OnboardingCompletedView.vue"),
    meta: {
      title: t("onboarding_kyc_title"),
    },
  },
  // TODO(ENG-1337): Rename product led onboarding routes
  ...(envIsDemoPreProd
    ? [
        {
          path: "/product-led-onboarding-getting-started",
          name: routeNames.PRODUCT_LED_ONBOARDING_CTA_VIEW,
          component: () => import("@/features/Onboarding/OnboardingProductLedCtaView.vue"),
          meta: {
            requiresAuth: false,
            title: t("onboarding_kyc_title"),
          },
        },
        {
          path: "/product-led-onboarding",
          name: routeNames.PRODUCT_LED_ONBOARDING_VIEW,
          component: () => import("@/features/Onboarding/OnboardingProductLedView.vue"),
          meta: {
            requiresAuth: false,
            title: t("onboarding_kyc_title"),
          },
        },
      ]
    : []),
];
